import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getProfileTest } from "../core/api/auth";

/**
 * AdminRoute - A component that restricts access to admin, management, and senior_accountant users
 * If the user is not authorized, they will be redirected to the clients page
 */
const AdminRoute = ({ children }) => {
  const profile = useSelector((state) => state.profile);
  console.log("Profile in AdminRoute:", profile);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        let userRole = null;
        // If we already have the user data in redux state
        if (authState && authState.user) {
          userRole = authState.user.role;
        } else if (profile) {
          userRole = profile.role;
        }

        // Allow admin, super_admin, management, and senior_accountant
        const authorizedRoles = [
          "admin",
          "super_admin",
          "management",
          "senior_accountant",
        ];
        setIsAuthorized(authorizedRoles.includes(userRole));
        setLoading(false);
      } catch (error) {
        console.error("Error checking admin status:", error);
        setLoading(false);
        setIsAuthorized(false);
      }
    };

    checkAdminStatus();
  }, [authState, profile]);

  // Show loading state
  if (loading) {
    return <div className="loading">Checking permissions...</div>;
  }

  // If user is authorized, render the protected component
  if (isAuthorized) {
    return children;
  }

  // If user is not authorized, redirect to clients page
  return <Navigate to="/clients" replace />;
};

export default AdminRoute;
